<div class="eula-container cardWithShadow px-[40px]!">
  @if (content) {
    <div class="ql-snow">
      <div class="ql-editor eula-content p-0!" (click)="onContentClick($event)">
        <app-html-formatter [htmlText]="content" />
      </div>
    </div>
  }
</div>
